// extracted by mini-css-extract-plugin
export var image = "gB_dc";